<template lang="html">
  <div class="wrapper fadeInDown">
    <div class="fadeIn first">
      <img src="@/assets/gw-standard-white.png" class="login-logo">
    </div>
    <div id="formContent">
      <div>
        <h4>{{$t('alerts.disableAlert')}}</h4>
        <span>{{$t('alerts.disableAlertText')}}</span>
      </div>
       <button class="btn btn-secondary mt-3 mr-2" @click="pushLogin">
         {{$t('general.cancel')}}
       </button>
       <button class="btn btn-success mt-3 ml-2" @click="handleClick">
         <span
           class="spinner-border spinner-border-sm"
           v-show="loading"
         />
         {{$t('general.confirm')}}
       </button>
    </div>
  </div>
</template>

<script>
import { disableAlerts } from '@/api/index';

export default {
  name: 'DisableAlert',
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async handleClick() {
      this.loading = true;
      disableAlerts(this.$router.currentRoute.params.token).then((res) => {
        this.loading = false;
        console.warn(res);
        this.$router.push('/login');
      })
        .catch(() => {
          this.loading = false;
        });
    },
    async pushLogin() {
      this.$router.push('/login');
    },
  },

};
</script>

<style lang="scss" scoped>
@import './login.scss';
</style>
